import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import styles from './RestrictedWordsItemWrapper.module.scss';

export interface RestrictedWordsItemWrapperProps {
  className?: string;
  onClick?: () => void;
}

export function RestrictedWordsItemWrapper(
  props: PropsWithChildren<RestrictedWordsItemWrapperProps>
) {
  const { children, className, onClick } = props;

  return (
    <div className={classNames(styles.container, className)} onClick={onClick}>
      {children}
    </div>
  );
}
